module.exports = __webpack_public_path__ + "static/media/body_bg2.eda06861.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/body_bg2.jpg
// module id = 1583
// module chunks = 10